export default __webpack_public_path__ + "static/media/illustration-mian-m.2989b32f.webp";